import { Component } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector   : 'noProducto',
    templateUrl: './noProd.component.html',
    styleUrls  : ['./noProd.component.scss'],
    animations   : fuseAnimations
})
export class NoProductoComponent
{
    /**
     * Constructor
     */
    constructor(private _fuseTranslationLoaderService: FuseTranslationLoaderService)
    {
      lang_wizard.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
    }
}
